// Web Notifications (F1-22) — aviso de sessão chegando + fim de ciclo pomodoro.
// Opt-in nas Configurações; permissão pedida na hora do toggle.

import { toLocalDateIso, todayLocalIso } from '@core/dates';
import { getState } from '@core/store';

export function notificationsSupported(): boolean {
  return typeof window !== 'undefined' && 'Notification' in window;
}

export function permissionState(): NotificationPermission | 'unsupported' {
  return notificationsSupported() ? Notification.permission : 'unsupported';
}

export async function requestPermission(): Promise<boolean> {
  if (!notificationsSupported()) return false;
  if (Notification.permission === 'granted') return true;
  const result = await Notification.requestPermission();
  return result === 'granted';
}

/** dispara se habilitado nas settings e permissão concedida */
export function notify(title: string, body?: string): void {
  if (!notificationsSupported()) return;
  if (!getState().settings.notifications_enabled) return;
  if (Notification.permission !== 'granted') return;
  try {
    new Notification(title, { body, icon: '/favicon.svg', tag: 'robox' });
  } catch {
    /* alguns browsers móveis exigem service worker — silencioso */
  }
}

// ===== Vigia de sessões planejadas =====
// Checa a cada 30s se alguma sessão de hoje começa nos próximos 5 min.
// Cada sessão avisa uma única vez por carga da página.

const alerted = new Set<string>();
let watcherId: ReturnType<typeof setInterval> | null = null;

function checkUpcoming(): void {
  const { sessions, contents, settings } = getState();
  if (!settings.notifications_enabled) return;
  const now = Date.now();
  const tIso = todayLocalIso();
  for (const s of sessions) {
    if (s.status !== 'planned' || alerted.has(s.id)) continue;
    if (toLocalDateIso(s.planned_at) !== tIso) continue;
    const startsIn = new Date(s.planned_at).getTime() - now;
    if (startsIn > 0 && startsIn <= 5 * 60 * 1000) {
      alerted.add(s.id);
      const title = contents.find((c) => c.id === s.content_id)?.title || 'Sessão de estudo';
      notify('⏰ Sessão em instantes', `${title} começa em ~${Math.ceil(startsIn / 60000)} min`);
    }
  }
}

export function startSessionWatcher(): () => void {
  if (watcherId) clearInterval(watcherId);
  watcherId = setInterval(checkUpcoming, 30_000);
  checkUpcoming();
  return () => {
    if (watcherId) clearInterval(watcherId);
    watcherId = null;
  };
}
